export default __webpack_public_path__ + "static/media/big_buddy_logo.17069c10.png";